export default "__VITE_ASSET__B5FJp3Yn__"